// extracted by mini-css-extract-plugin
export default {"hint":"Hint_hint__A3EUQ","hint-points":"Hint_hint-points__3jbrH"};